import * as React from 'react'

// Ids of bookable resources (equipment, materials, …) that are disabled for the
// workflow type currently being configured — not bookable, or excluded by their
// workflow types. Provided by DisabledResourceIdsProvider so the dependent
// resource selectors (conditional filters and conditional fields) can exclude
// them uniformly, the same way the "Allow to select" picker already hides them.
export const DisabledResourceIdsContext = React.createContext<Set<string>>(
  new Set(),
)
